module.exports = __webpack_public_path__ + "img/chat-square.902cf22c.svg";